import React, { useEffect, useState } from "react";
import { useAxios } from "../../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../../environment/BackendService";
import { fetchDropdownValues } from "../../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../../common_nextgen/utils/Constants";
import { useToast } from "../../../../common_nextgen/hooks/ToastContext";
import { LegacyResolvers } from "../../../../common_nextgen/utils/UtilFunctions";
import { downloadCSV } from "../../../../common_nextgen/utils/UtilFunctions";

const usePlanOverride = (
  onSelect,
  hideModal,
  initialSelectParams,
  initialLookupType,
  selectedParamData
) => {
  const [data, setData] = useState([]); /* Price Schedule Data */
  const { axios_helper_no_header } = useAxios();
  const initialParams = {
    planEffDate: selectedParamData?.planEffDate||"",
    planTermDate: selectedParamData?.planTermDate||"",
    planCode: selectedParamData?.planCode||"",
    planName: selectedParamData?.planName||"",
    hiddenRecordIndicator: "A",
  };

  const [paramsData, setParamsData] = useState(initialParams);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const [lookupType, setLookupType] = useState(initialLookupType);
  const [selectParams, setSelectParams] = useState(initialSelectParams);

  const toast = useToast();
  const location = useLocation();
  const {} = ROUTE_PATHS;

  const screen_title = "Select Plan by Plan Code";
  const screenNumber = "RCPLN018";

  //const { state: stateVal } = location;
  const stateVal = location.state || [];
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  const { previousScreen = "/", params } = currentState;

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "Plan Code",
      name: "planCode",
      label: "Plan Code",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "Plan Name",
      name: "planName",
      label: "Plan Description",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 25,
    },
    {
      fieldLabel: "Hidden Records Indicator*ActiveAll",
      name: "hiddenRecordIndicator",
      label: "Status",
      type: "dropdown",
      value: "",
      maxLength: 1,
    },
    {
      fieldLabel: "Plan Eff Date",
      name: "planEffDate",
      label: "From Date",
      type: "date",
      fieldNature: "editable",
      value: "",
      maxLength: 6,
      options: {
        format: "MM/DD/YYYY",
      },
    },
    {
      fieldLabel: "Plan Term Date",
      name: "planTermDate",
      label: "Thru Date",
      type: "date",
      fieldNature: "editable",
      value: "",
      maxLength: 6,
      options: {
        format: "MM/DD/YYYY",
      },
    },
  ];

  const dropdownOptions = [
    { fieldLabel: "Hidden Records Indicator", condition: "*ActiveAll" },
  ];
  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.fieldLabel + item.condition),
  };
  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: () => {
        if (lookupType === "external") {
          const message = {
            type: "hideModal",
          };
          window.parent.postMessage(message, "*");
        } else {
          hideModal();
        }
      },
      button_key: "F12",
    },
  ];

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = [
    // {
    //   button_label: "Add Select Plan by Plan Code",
    //   button_handeler: () => {
    //     navigateToPage(ADD_PRICE_SCHEDULE);
    //   },
    //   button_key: "F6",
    // },
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  /* Gear Icon Menu option CTAs */
  const menuOptions = [
    {
      label: "Select",
      icon: <span className="material-icons">add</span>,
      command: () => {
        //console.log("Select");
        // console.log("rowData", rowData);
        /*const [latestPreviousState] = previousState.splice(
          previousState.length - 1,
          1
        );
        let { formData } = latestPreviousState;
        const updatedData = params.reduce((filteredObj, key) => {
          if (rowData[key]) return { ...filteredObj, [key]: rowData[key] };
          return filteredObj;
        }, {});
        console.log("selected data", updatedData);
        navigateToPage(previousScreen, [
          ...previousState,
          { ...latestPreviousState, formData: { ...formData, ...updatedData } },
        ]);
      },*/
        const paramData = selectParams.reduce((acc, key) => {
          if (rowData.hasOwnProperty(key["target"])) {
            acc[key["source"]] = rowData[key["target"]];
          }
          return acc;
        }, {});
        if (lookupType === "local") {
          onSelect(paramData);
        } else {
          const message = {
            type: "responseData",
            data: paramData,
          };
          window.parent.postMessage(message, "*");
        }
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: () => {
        const {formatDateForPresto}=LegacyResolvers;
        const message = {
          message: "navigate-to-presto",
          programCode: "RCPLN013I",
          parameters: {
            planName: rowData["planName"],
            planEffDate: formatDateForPresto(rowData["planEffDate"]), //mm/dd/yyyy, yyyy-mm-dd
            planCode: rowData["planCode"],
          },
        };
        console.log(message);
        window.top?.postMessage(message, "*");
      },
    },
  ];

  /* Data table column info. */
  const columnDef = [
    {
      header: "Plan Code",
      field: "planCode",
    },
    {
      header: "From Date",
      field: "planEffDate",
    },
    {
      header: "Thru Date",
      field: "planTermDate",
    },
    {
      header: "Description",
      field: "planName",
    },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "counter";

  /* Handler that fetches the data */
  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/rcplnp`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  const handleMessage = (event) => {
    const { type, data } = event.data;
    if (type === "initData") {
      const { selectMode, data: paramData } = data;

      setLookupType(paramData.params);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  useEffect(() => {
    fetchData(); // Initial fetch with page 0 and page size 10
  }, [paramsData, rows, currentPage, selectedOption]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    console.log(selectedOption);
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deletePriceSchedule = () => {
    if (selectedOption === "yes") {
      const params = { prcPriceScheduleName: rowData[parmKey] };
      axios_helper_no_header("DELETE", "api/priceschedule", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/rcplnp/exportcsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deletePriceSchedule,
    setSelectedOption,
    leftButtons,
  };
};

export default usePlanOverride;
